<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A7rgG8/tc-custom/9780830899357.jpg?1696025157738" alt="This image is the cover for the book Isaiah, Tyndale Old Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Isaiah, Tyndale Old Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p>The book of Isaiah is perhaps the most compelling of all Old Testament prophecy. No other prophet rivals Isaiah's brilliance of style, powerful imagery and clear vision of the messianic hope. Isaiah's prophetic ministry begins with his temple vision and calling: "I heard the voice of the Lord saying, 'Whom shall I send?'" Through a series of oracles Isaiah calls Israel and the nations to turn to the Lord, for judgment is coming. He announces that redemption is found in the Davidic Servant alone. Finally, in the "day of vengeance and the year of redemption" the Anointed Conqueror will punish rebellious peoples, comfort the contrite and reestablish the glory of Zion. J. Alec Motyer, author of the unparalleled one-volume commentary<em>The Prophecy of Isaiah,</em> now provides the long-awaited final volume in the Tyndale Old Testament Commentary Series. Unlike many Isaiah commentators who divide the book between chapters 1-39 and 40-66, Motyer instead identifies three messianic portraits: the King (Isaiah 1-37), the Servant (Isaiah 38-55), and the Anointed Conqueror (Isaiah 56-66). This volume provides Motyer's lucid exposition on these three portraits, examining Isaiah with insightful and probing passage-by-passage commentary. All who study the text of Isaiah will find here expert scholarship and solid footing for unraveling difficult issues of exegesis and interpretation. The original, unrevised text of this volume has been completely retypeset and printed in a larger, more attractive format with the new cover design for the series.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Alec Motyer
      </h2>
      
      <p class="authorDescription body article"><p>J. Alec Motyer (1924–2016) was a renowned Old Testament pastor and scholar. With extensive experience in parish ministry, he was principal of Trinity College in Bristol, England, and was well known as a Bible expositor. His books include <em>The Prophecy of Isaiah</em>, and he was the Old Testament editor of The Bible Speaks Today commentary series.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eeb7025e